const accountParams = (accountId, params) => ({
  accountId,
  ...params,
});

export const postSaleTableActionLocation = ({
  accountId,
  action,
  postSaleCase,
}) => {
  if (!accountId || !postSaleCase) return null;

  if (action === 'status') {
    return {
      name: 'operacao_imobiliaria_pos_venda_status',
      params: accountParams(accountId, {
        postSaleCaseId: postSaleCase.id,
      }),
    };
  }

  if (action === 'review') {
    if (!postSaleCase.property_transaction_id) return null;

    return {
      name: 'operacao_imobiliaria_pos_venda_devolucao',
      params: accountParams(accountId, {
        salesTransactionId: postSaleCase.property_transaction_id,
      }),
    };
  }

  if (action === 'nucleo') {
    if (!postSaleCase.property_transaction_id) return null;

    return {
      name: 'operacao_imobiliaria_pos_venda_pedidos_servico',
      params: accountParams(accountId, {
        salesTransactionId: postSaleCase.property_transaction_id,
      }),
    };
  }

  if (action === 'details') {
    return {
      name: 'operacao_imobiliaria_pos_venda_detalhes',
      params: accountParams(accountId, {
        postSaleCaseId: postSaleCase.id,
      }),
    };
  }

  return null;
};
